import React from 'react';

import { overlay, formWrap } from './styles.module.scss';
import WebinarOnDemandForm from 'components/Forms/WebinarOnDemand/index';
import ButtonCloseOverlay from '../ButtonCloseOverlay/index';

const FormOverlay = ({ data, closeOverlay, lang, allowVideo }) => {
  return (
    <div className={overlay}>
      <ButtonCloseOverlay closeOverlay={closeOverlay} />

      <div className={formWrap}>
        <WebinarOnDemandForm data={data} lang={lang} allowVideo={allowVideo} />
      </div>
    </div>
  );
};

export default FormOverlay;
